import css from "@styled-system/css";
import styled from "styled-components";

import Box from "../Box/Box";

const SliderContainer = styled(Box)`
  outline: none;
  position: relative;
  ${(props) =>
    css({
      [`&[data-uuid="${props["data-uuid"]}"]:hover, &[data-uuid="${props["data-uuid"]}"]:focus`]:
        {
          [`.pagination > input[type="range"]`]: {
            opacity: "1 !important",
          },
          "> .slick-slider": {
            "> .slick-dots": {
              opacity: "1 !important",
            },
            "> .slick-arrow.slick-next:not(.slick-disabled), > .slick-arrow.slick-prev:not(.slick-disabled) ":
              {
                display: "flex !important",
              },
          },
        },
    })}
`;

export default SliderContainer;
